import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

interface DocumentsRequestCancellationParam {
  documentId: string;
  message: string;
  workspaceId: string;
}

/**
 * POST 요청 취소
 * @deprecated Endpoint path and response are modified in standardize-document-content
 * @see https://www.notion.so/bb8e24e723434ecc946dfecb85db5ee3#6d2118a392fc430ba8f3bd7174c3e6b3
 */
// TODO: (standardize-document-content): 응답이 소비되는 곳이 없어 응답에 대한 처리를 생략했는데, 추후 함수 이름 수정 및 더블체크하기
// eslint-disable-next-line import/prefer-default-export
export function postDocumentsRequestCancellation({
  documentId,
  message,
  workspaceId,
}: DocumentsRequestCancellationParam) {
  return requestApi({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/cancel-request`),
    method: 'POST',
    data: {
      // FIXME: blockSignerAccess 옵션 통합하기 - 참고 스레드: https://modusign.slack.com/archives/C03334LUVM4/p1649233867414649
      message,
    },
    credentials: true,
  });
}
